import { render, staticRenderFns } from "./EmergencyContacts.vue?vue&type=template&id=1e741fee&scoped=true"
import script from "./EmergencyContacts.vue?vue&type=script&lang=js"
export * from "./EmergencyContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e741fee",
  null
  
)

export default component.exports